// extracted by mini-css-extract-plugin
export default {"container":"NumberBlock_container__UntAn"};